export const USER_INSERT = 'USER_INSERT'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_DELETE = 'USER_DELETE'
